export const paths = {
  base: '',
  loginError: 'login-error',
  session: 'session/:sessionId',
  adBlocker: 'ad-blocker',
  inactive: 'inactive',
  newUser: 'new-user-setup',
}
